import { ReactNode, useCallback, useMemo, useState } from "react";

import { PaymentContext } from "./payment.context";

type Props = { children: ReactNode };

export const PaymentProvider = ({ children }: Props): JSX.Element => {
  const [paymentData, setPaymentData] = useState<
    | {
        [key: string]: string | number | object;
      }
    | undefined
  >(undefined);

  const handlePaymentData = useCallback(
    (data: { [key: string]: string | number | object }) => {
      setPaymentData(data);
    },
    []
  );

  const paymentState = useMemo(
    () => ({ paymentData, handlePaymentData }),
    [paymentData, handlePaymentData]
  );

  return (
    <PaymentContext.Provider value={paymentState}>
      {children}
    </PaymentContext.Provider>
  );
};
